export default __webpack_public_path__ + "static/media/Readings.54b879f1.webp";